<template>
  <div
    class="flex space-x-1 rounded bg-gray-100 p-2"
  >
    <button
      type="button"
      class="flex w-1/12 items-center justify-center text-main-primary outline-none"
      @click="viewFile"
    >
      <FileUploadIcon />
    </button>
    <div class="w-9/12 overflow-hidden text-ellipsis text-gray-500">
      <div class="overflow-hidden text-ellipsis no-localize-translate">
        {{ formatFileName(getFileName) }}
      </div>
      <div
        v-if="getFileSize"
        class="mt-0 text-sm"
      >
        {{ getFileSize }}
      </div>
    </div>
    <div class="flex w-2/12 items-center justify-end gap-2">
      <ButtonWithIcon
        bg-colors="bg-main-primary hover:bg-main-secondary active:bg-main-primary"
        classes="rounded-full"
        style="padding: 5px !important"
        @click="onDownload"
      >
        <template #icon>
          <DownloadIcon />
        </template>
      </ButtonWithIcon>
      <ButtonWithIcon
        v-if="canUnlink"
        bg-colors="bg-red-600 hover:bg-red-600 active:bg-red-600"
        classes="rounded-full"
        style="padding: 5px !important"
        :disabled="!readyToUnlink"
        @click="onUnlink"
      >
        <template #icon>
          <UnlinkIcon />
        </template>
      </ButtonWithIcon>
    </div>
    <AttachmentViewer :file-name="getFileName" />
  </div>
</template>

<script>
export default {
  name: 'DataPointAttachmentContainer',

  props: {
    file: {
      type: [String, Object],
      default: () => null,
    },
    canUnlink: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['unlink', 'download'],

  computed: {
    getFileName() {
      return typeof this.file === 'string'
        ? this.file
        : this.file?.document_name
    },
    getFileSize() {
      if (typeof this.file === 'string') {
        return null
      }
      return Number((this.file.file_size / 1024).toFixed(2)) > 1024
        ? (this.file.file_size / 1024 / 1024).toFixed(2) + 'MB'
        : (this.file.file_size / 1024).toFixed(2) + 'KB'
    },
    readyToUnlink() {
      return typeof this.file !== 'string'
    },
  },

  methods: {
    onUnlink() {
      this.$emit('unlink', {
        ...this.file,
        fileName: this.formatFileName(this.getFileName),
      })
    },
    onDownload() {
      this.$emit('download', this.getFileName)
    },
    formatFileName(fileName) {
      const parts = fileName.split('-')
      return parts[parts.length - 1]
    },
    viewFile() {
      this.$modal.show(this.getFileName)
    },
  },
}
</script>
